import React, { useEffect } from "react";
import NotificationAlert from "react-notification-alert";

// react-bootstrap components
import { Button, Card, Form, Container, Row, Col } from "react-bootstrap";
import { useParams, useHistory } from "react-router-dom";
import { ligneImsAdded, ligneImsGetById } from "../../../Redux/ligneImsReduce";
import { useDispatch } from "react-redux";

function AjouterLigneIms({ client }) {
  const dispatch = useDispatch();
  const location = useParams();
  const navigate = useHistory();
  if (isNaN(location.id) === true) document.title = "Ajouter un ligne ims";
  else document.title = "Modifier le ligne ims";
  const [nom, setNom] = React.useState("");
  const [iframe, setIframe] = React.useState(null);
  const [id, setId] = React.useState(0);

  const notificationAlertRef = React.useRef(null);

  const notify = (place, msg, type) => {
    var options = {};
    options = {
      place: place,
      message: (
        <div>
          <div>{msg}</div>
        </div>
      ),
      type: type,
      icon: "nc-icon nc-bell-55",
      autoDismiss: 7,
    };
    notificationAlertRef.current.notificationAlert(options);
  };
  function submitForm(event) {
    if (nom === "")
      notify("tr", "Ligne Ims est obligatoire", "danger");
    else {
      dispatch(ligneImsAdded({ nom, id, iframe })).then(e => {
        if (e.payload === true) {
          if (isNaN(location.id) === true)
            notify("tr", "Insertion avec succes", "success")
          else
            notify("tr", "Modifier avec succes", "success");
          setTimeout(async () => {
            listeLigneIms();
          }, 1500);
        } else {
          notify("tr", "Problème de connexion", "danger");
        }
      });
    }
  }

  useEffect(() => {
    async function getLigneIms() {
      if (isNaN(location.id) === false) {
        var ligneIms = await dispatch(ligneImsGetById(location.id));
        var entities = ligneIms.payload;
        if (entities === false) {
          navigate.push(client + '/listLigneIms');
        }
        else {
          setNom(entities.nom);
          setIframe(entities.iframe);
          setId(location.id);
        }
      }
    }
    getLigneIms();
  }, [location.id, dispatch, navigate]);

  function listeLigneIms() {
    navigate.push(client + '/listLigneIms');
  }
  return (
    <>
      <Container fluid>
        <div className="rna-container">
          <NotificationAlert ref={notificationAlertRef} />
        </div>
        <div className="section-image">
          <Container>
            <Row>
              <Col md="12">
                <Button
                  id="saveBL"
                  className="btn-wd btn-outline mr-1 float-left"
                  type="button"
                  variant="info"
                  onClick={listeLigneIms}
                >
                  <span className="btn-label">
                    <i className="fas fa-list"></i>
                  </span>
                  Retour à la liste
                </Button>
              </Col>
            </Row>
            <Row>
              <Col md="12">
                <Form action="" className="form" method="">
                  <Card>
                    <Card.Header>
                      <Card.Header>
                        <Card.Title as="h4">
                          {typeof location.id == "undefined" ? "Ajouter ligne Ims" : "Modifier ligne Ims"}
                        </Card.Title>
                      </Card.Header>
                    </Card.Header>
                    <Card.Body>
                      <Row>
                        <Col className="pr-1" md="6">
                          <Form.Group>
                            <label>Nom * </label>
                            <Form.Control
                              defaultValue={nom}
                              placeholder="Nom"
                              type="text"
                              onChange={(value) => {
                                setNom(value.target.value);
                              }}
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                        {/* 
                        <Col className="pr-1" md="6">
                          <Form.Group>
                            <label>Iframe   </label>
                            <Form.Control
                              defaultValue={iframe}
                              placeholder="Iframe"
                              type="text"
                              onChange={(value) => {
                                setIframe(value.target.value);
                              }}
                            ></Form.Control>
                          </Form.Group>
                        </Col> */}
                      </Row>

                      <Button
                        className="btn-fill pull-right"
                        type="button"
                        variant="info"
                        onClick={submitForm}
                      >
                        Enregistrer
                      </Button>
                      <div className="clearfix"></div>
                    </Card.Body>
                  </Card>
                </Form>
              </Col>
            </Row>
          </Container>
        </div>
      </Container>
    </>
  );
}

export default AjouterLigneIms;
